import React from 'react';

const FacultyCard = ({ faculty }) => {
  const { name, subject, qualification, experience, imageURL } = faculty;
  return (
    <article className="ngt-faculty-card" itemScope itemType="https://schema.org/Person">
      {imageURL
        ? <img src={imageURL} alt={name} itemProp="image" loading="lazy" />
        : (
          <div style={{ width: '100%', height: '220px', background: 'linear-gradient(135deg,var(--ngt-navy),var(--ngt-mid))', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="fas fa-user-tie" style={{ fontSize: '4rem', color: 'rgba(255,255,255,0.4)' }}></i>
          </div>
        )
      }
      <div className="fc-body">
        <h5 itemProp="name">{name}</h5>
        <div className="fc-subject" itemProp="jobTitle">{subject}</div>
        {qualification && <p className="fc-qual" itemProp="description">{qualification}</p>}
        {experience && <p className="fc-qual">{experience}</p>}
      </div>
    </article>
  );
};

export default FacultyCard;
